import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'common/drawers/contactDrawer/CLOSE',
  OPEN_ERROR: 'common/drawers/contactDrawer/OPEN_ERROR',
  OPEN_REQUEST: 'common/drawers/contactDrawer/OPEN_REQUEST',
  OPEN_SUCCESS: 'common/drawers/contactDrawer/OPEN_SUCCESS',
  SAVE_ERROR: 'common/drawers/contactDrawer/SAVE_ERROR',
  SAVE_REQUEST: 'common/drawers/contactDrawer/SAVE_REQUEST',
  SAVE_SUCCESS: 'common/drawers/contactDrawer/SAVE_SUCCESS',
  SET_CONTACT: 'common/drawers/contactDrawer/SET_CONTACT',
};

export const contactDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  setContact: ({ contact }) => ({
    type: types.SET_CONTACT,
    payload: { contact },
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to edit contact',
  ),
  request: ({
    allowCreateAccount,
    contactId,
    callBack,
    includeAccountSelect,
    mode,
  }) => ({
    type: types.OPEN_REQUEST,
    payload: {
      allowCreateAccount,
      contactId,
      callBack,
      includeAccountSelect,
      mode,
    },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save contact',
  ),
  request: ({
    accountId,
    address1,
    address2,
    city,
    country,
    email,
    firstName,
    lastName,
    notes,
    phone,
    phoneExt,
    postalCode,
    salespersonId,
    state,
  }) => ({
    type: types.SAVE_REQUEST,
    payload: {
      accountId,
      address1,
      address2,
      city,
      country,
      email,
      firstName,
      lastName,
      notes,
      phone,
      phoneExt,
      postalCode,
      salespersonId,
      state,
    },
  }),
  success: ({ contactId, contact }) => ({
    type: types.SAVE_SUCCESS,
    payload: { contactId, contact },
  }),
};
